import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaMapMarkerAlt, FaEnvelope, FaPhone, FaGlobe } from 'react-icons/fa';
import { courses } from '../constants/courses';
import logo from '../images/logo.png';

const sections = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'courses', label: 'Courses' },
  { id: 'contact', label: 'Contact' },
];

const socials = [
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/share/1Q4K2VtNUm/?mibextid=wwXIfr',
    icon: FaFacebook,
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/actech_2025?igsh=eGY0aWpneWpyY3hi',
    icon: FaInstagram,
  },
];

const contact = [
  { icon: FaMapMarkerAlt, value: 'Ramdabazar, Alinagar, Beanibazar, Sylhet' },
  { icon: FaPhone, value: '+8801623607784', href: 'tel:+8801623607784' },
  { icon: FaEnvelope, value: 'actechinstitute2024@gmail.com', href: 'mailto:actechinstitute2024@gmail.com' },
  { icon: FaGlobe, value: 'www.actech.institute', href: 'https://www.actech.institute', external: true },
];

const Footer = () => {
  const navigate = useNavigate();

  const goToSection = (sectionId) => navigate('/', { state: { scrollTo: sectionId } });

  return (
    <footer className="border-t border-surface-line bg-surface-sunken">
      <div className="container-page py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3">
              <img src={logo} alt="" className="h-9 w-9 object-contain" />
              <span className="text-sm font-semibold text-ink">AC Tech Institute</span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-ink-muted">
              Practical, hands-on training in technology, design and communication &mdash; based in
              Beanibazar, Sylhet.
            </p>
            <div className="mt-6 flex gap-3">
              {socials.map(({ label, href, icon: Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="flex h-9 w-9 items-center justify-center rounded-lg border border-surface-line text-ink-muted transition-colors duration-200 hover:border-brand-500/60 hover:text-brand-400"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Navigate */}
          <nav>
            <h2 className="text-xs font-semibold uppercase tracking-[0.16em] text-ink-faint">
              Navigate
            </h2>
            <ul className="mt-5 space-y-3">
              {sections.map(({ id, label }) => (
                <li key={id}>
                  <button
                    onClick={() => goToSection(id)}
                    className="text-sm text-ink-muted transition-colors hover:text-ink"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          {/* Courses */}
          <nav>
            <h2 className="text-xs font-semibold uppercase tracking-[0.16em] text-ink-faint">
              Courses
            </h2>
            <ul className="mt-5 space-y-3">
              {courses.map(({ id, title }) => (
                <li key={id}>
                  <button
                    onClick={() => navigate(`/courses/${id}`)}
                    className="text-left text-sm text-ink-muted transition-colors hover:text-ink"
                  >
                    {title}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          {/* Contact */}
          <div>
            <h2 className="text-xs font-semibold uppercase tracking-[0.16em] text-ink-faint">
              Contact
            </h2>
            <ul className="mt-5 space-y-4">
              {contact.map(({ icon: Icon, value, href, external }) => (
                <li key={value} className="flex items-start gap-3">
                  <Icon className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-brand-500" />
                  {href ? (
                    <a
                      href={href}
                      {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                      className="break-words text-sm text-ink-muted transition-colors hover:text-ink"
                    >
                      {value}
                    </a>
                  ) : (
                    <span className="text-sm text-ink-muted">{value}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-surface-line pt-8">
          <p className="text-center text-xs text-ink-faint">
            &copy; {new Date().getFullYear()} AC Tech Institute. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
